<!--
 * @Author: xuchen
 * @Date: 2020-03-16 15:31:53
 * @Desc: 图片切换平台
 -->
<template>
  <div class="swiper-platform-container">
    <div class="swiper-platform-content">
      <ul class="img-list-container" :style="`transform: translateX(${moveLeftDistance})`">
        <li
          v-for="item in dataProvider"
          :key="item.enterpriseCode"
          :class="[
            'img-item-container',
            { actived: selectedEnterpriseKey === item.enterpriseCode }
          ]"
          @click="handleSelectEnterp(item.enterpriseCode)"
        >
          <img v-if="!item.url" :src="defaultEnterpriseImg" class="default-enterprise-img" />
          <img v-if="item.url" :src="item.url" :alt="item.enterpriseName" />
          <div v-ellipsis class="desc">{{ item.enterpriseName }}</div>
        </li>
      </ul>
    </div>
    <div class="arrow-left arrow-icon" @click="handleMoveLeft">
      <i class="h-icon-angle_left"></i>
    </div>
    <div class="arrow-right arrow-icon" @click="handleMoveRight">
      <i class="h-icon-angle_right"></i>
    </div>
  </div>
</template>

<script>
import defaultEnterpriseImg from '@/assets/images/enterpriseVideoInspection/enterprise_default.png'
export default {
  name: 'SwiperPlatform',
  props: {
    // 工厂数据源
    dataProvider: {
      type: Array,
      default: () => []
    },

    // 初始选择的企业主键
    defaultSelectedEnterpKey: {
      type: [Number, String],
      default: ''
    },

    // 当前选中的企业主键
    selectedEnterpriseKey: {
      type: [Number, String],
      default: ''
    },

    // 一行展示7个企业
    rowEnterpriseNum: {
      type: Number,
      default: 7
    }
  },
  data() {
    return {
      defaultEnterpriseImg,
      enterpriseWidth: 160, // 企业容器的宽度
      moveLeftNum: 0 // 移动到左边n个公司块
    }
  },
  computed: {
    // 移动到左侧的距离
    moveLeftDistance() {
      return `${this.moveLeftNum * this.enterpriseWidth}px`
    }
  },
  watch: {
    /**
     * @author xuchen
     * @date 2020-03-17 19:17:46
     * @desc 初始化定位位置
     */
    defaultSelectedEnterpKey: {
      handler(val) {
        const matchIdx = this.dataProvider.findIndex(i => i.enterpriseCode === val)
        const moveRowNum = parseInt(matchIdx / this.rowEnterpriseNum)
        this.moveLeftNum = -moveRowNum * this.rowEnterpriseNum
      },
      immediate: true
    }
  },
  methods: {
    /**
     * @author xuchen
     * @date 2020-03-16 16:32:26
     * @desc 选择企业
     */
    handleSelectEnterp(key) {
      this.$emit('selectEnterprise', key)
    },

    /**
     * @author xuchen
     * @date 2020-03-17 17:45:36
     * @desc 左移动
     */
    handleMoveRight() {
      // 移动到最后一个
      const { rowEnterpriseNum, moveLeftNum } = this

      if (Math.abs(this.moveLeftNum) + rowEnterpriseNum >= this.dataProvider.length) {
        // this.$emit('getMoreData')
        return
      }
      this.moveLeftNum = moveLeftNum - rowEnterpriseNum
    },

    /**
     * @author xuchen
     * @date 2020-03-17 17:45:36
     * @desc 右移动
     */
    handleMoveLeft() {
      // 已经是第一个
      if (this.moveLeftNum >= 0) return
      const { rowEnterpriseNum, moveLeftNum } = this
      this.moveLeftNum = moveLeftNum + rowEnterpriseNum
    },
    /**
     * @Author: maogangfeng
     * @Date: 2020-04-01 14:51:00
     * @Desc: 判断是否需要向右移动一次
     */
    shouldMoveRight(index) {
      if (index === Math.abs(this.moveLeftNum) + this.rowEnterpriseNum) {
        return true
      }
    },
    /**
     * @Author: maogangfeng
     * @Date: 2020-04-01 14:51:02
     * @Desc: 判断是否需要向左移动一次
     */
    shouldMoveLeft(index) {
      if (index === Math.abs(this.moveLeftNum)) {
        return true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.swiper-platform-container {
  position: relative;
  width: 1120px;
  height: 88px;
  margin: 0 auto;
  .arrow-icon {
    position: absolute;
    top: 0;
    width: 24px;
    height: 88px;
    line-height: 88px;
    text-align: center;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 2px;
    font-size: 18px;
    color: rgba(255, 255, 255, 0.7);
    cursor: pointer;
    &:hover {
      color: rgba(255, 255, 255, 0.8);
      border-color: rgba(255, 255, 255, 0.3);
    }
    &:active {
      color: rgba(255, 255, 255, 0.6);
      border-color: rgba(255, 255, 255, 0.2);
    }
  }
  .arrow-left {
    left: -36px;
  }
  .arrow-right {
    right: -36px;
  }
  .swiper-platform-content {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .img-list-container {
    height: 100%;
    width: 9000000%;
    transition: transform 2s;
  }
  .img-item-container {
    float: left;
    width: 148px;
    height: 100%;
    margin: 0 6px;
    border: 2px solid transparent;
    position: relative;
    &:hover {
      opacity: 0.8;
    }
    &.actived {
      border-color: #ffcc00;
    }
    cursor: pointer;
    img {
      display: inline-block;
      width: 100%;
      height: 100%;
      border: none;
    }
    .default-enterprise-img {
      width: 100%;
      height: 100%;
      background-color: #ebebeb;
      object-fit: none;
    }
    .desc {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 144px;
      height: 24px;
      line-height: 24px;
      text-align: center;
      font-size: 12px;
      background: rgba(0, 0, 0, 0.77);
      color: #fff;
    }
  }
}
</style>
